/**
 * Texts (`en`) of the «reception» slice of Quality and HACCP (OBR-167). Own slice: `en.ts` is not touched.
 * The three languages must have the same keys (i18n.test.ts); no literal text in the views.
 */

export const receptionEn = {
  'backoffice.qualityReception': {
    // ── «Conservation conditions» master ──────────────────────────────────────────────
    conservationTempMin: 'Minimum temperature (°C)',
    conservationTempMax: 'Maximum temperature (°C)',
    conservationRangeHint:
      'Leave a limit blank if there is none. Outside the range, reception asks what to do with the goods.',
    conservationRequires: 'Temperature must be written down on receipt',
    conservationRequiresHint:
      'Whoever receives an article with this condition will have to enter the temperature it arrived at.',
    conservationColRange: 'Range on receipt',
    conservationColRequires: 'Temperature required',
    conservationRangeNone: 'No range',
    conservationRangeBetween: '{{min}} to {{max}} °C',
    conservationRangeAtLeast: 'At least {{min}} °C',
    conservationRangeAtMost: 'At most {{max}} °C',
    conservationRequiresYes: 'Yes',
    conservationRequiresNo: 'No',
    conservationTempInvalid: 'Enter a temperature between {{min}} and {{max}} °C.',
    conservationRangeOrder: 'The minimum cannot be greater than the maximum.',

    // ── Line control (manual reception register) ──────────────────────────────────────
    sectionTitle: 'Quality control',
    temperature: 'Temperature (°C)',
    temperatureRequired: 'Temperature (°C), required',
    temperatureRange: 'Acceptable range: {{range}}',
    temperatureStatus_ok: 'Within range',
    temperatureStatus_low: 'Below the minimum',
    temperatureStatus_high: 'Above the maximum',
    temperatureMissing: 'The temperature must be written down.',
    temperatureUnreadable: 'Enter a valid temperature (for example 3.5 or -18).',
    packaging: 'Packaging',
    labeling: 'Labeling',
    checkNone: 'Not checked',
    checkOk: 'OK',
    checkKo: 'KO',
    issuesNotice: 'Something is off: {{list}}. A non-conformity will be recorded.',
    issue_temperature_out_of_range: 'temperature out of range',
    issue_packaging_ko: 'damaged packaging',
    issue_labeling_ko: 'incorrect labeling',
    decision: 'Decision',
    decisionNone: 'Choose what to do',
    decision_accepted: 'Accept the goods',
    decision_accepted_with_incident: 'Accept with incident',
    decision_rejected: 'Reject the goods',
    decisionMissing: 'Choose what to do with this entry.',
    rejectedHint:
      'Rejecting the goods blocks them in stock and leaves a pending return to the supplier.',
    derivedNok: 'Non-conforming by quality control',
    missingBlocker: 'the quality control of an entry (temperature or decision)',

    // ── Delivery-note detail ──────────────────────────────────────────────────────────
    colQuality: 'Quality control',
    detailTemperature: 'Temperature: {{value}} °C',
    detailPackaging: 'Packaging: {{status}}',
    detailLabeling: 'Labeling: {{status}}',
    detailDecision: 'Decision: {{decision}}',
    detailRecordedAt: 'Checked on {{when}}',
    detailRecordedBy: 'Checked by {{user}} on {{when}}',
    detailNonConformity: 'Non-conformity {{code}}',
    detailNonConformityOpen: 'Open {{code}}',
    detailNoControl: '—',
  },
} as const;
